import { useMutation, useQueryClient } from '@tanstack/react-query'
import api from '@/lib/api'
import type { MvaDashboard } from '@/types/mva'

type SaveMvaGtinsPayload = {
  items: Array<{
    cEAN: string
    xProd: string
    uCom: string
    ncm: string
    cest?: string | null
    quantidadeEmbalagem: number
  }>
}

export function useSaveMvaGtins(id_apuracao?: string) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (payload: SaveMvaGtinsPayload) => {
      if (!id_apuracao) throw new Error('ID da apuração não fornecido')

      const response = await api.put<{ data: MvaDashboard }>(`/mva/${id_apuracao}/gtins`, payload)
      return response.data.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['mva-dashboard', id_apuracao] })
    }
  })
}
